/**
 * World Cup 2026 Theme - Global JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
  try {
    initScrollNewsletterPopup();
  } catch (e) {}

  window.addEventListener('pageshow', function(ev) {
    if (!ev.persisted || !window.__wcSnlTeardown) return;
    try {
      window.__wcSnlTeardown();
    } catch (e2) {}
    window.__wcSnlInitialized = false;
    try {
      initScrollNewsletterPopup();
    } catch (e3) {}
  });

  // Initialize cart functionality
  initCart();
  
  // Initialize product forms
  initProductForms();
  
  // Initialize quantity selectors
  initQuantitySelectors();
  
  // Initialize scroll animations
  initScrollAnimations();
  
  // Initialize mobile menuå
  initMobileMenu();

  initCartDrawer();

  initWorldCupCountdown();
});

/**
 * 滚动促销弹窗：首页 Shop Now、产品页加购（集合/catalog 页面不渲染弹窗）。
 */
function scrollNlTargetTemplate() {
  var b = document.body;
  if (!b) return false;
  return (
    b.classList.contains('template-index') ||
    b.classList.contains('template-product')
  );
}

function initScrollNewsletterPopup() {
  if (window.__wcSnlInitialized) return;
  var root = document.getElementById('scroll-newsletter-popup');
  if (!root) return;
  if (document.body.classList.contains('template-password')) return;
  if (!scrollNlTargetTemplate()) return;

  /** 可选：清除旧版「多日不弹」遗留的 localStorage（本逻辑已不再使用） */
  try {
    if (/[?&]scroll_nl_reset=1(?:&|$)/.test(window.location.search)) {
      localStorage.removeItem('worldcupNlDismissUntil_v8');
      localStorage.removeItem('worldcupNlDismissUntil_v7');
    }
  } catch (e) {}

  var form = root.querySelector('form.scroll-newsletter-popup__form--subscribe');

  var opened = false;
  /** 为 true 时允许在滚过触发线后弹出；关窗后置 false，需向上滚过释放区再变 true */
  var armed = true;
  /** 页面不足一屏：关窗后本页不再自动弹，避免关闭瞬间连续弹出 */
  var shortPageLocked = false;
  var pollId = null;
  var delayTimerId = null;
  var resizeObserver = null;
  /** 除 window/document 外额外绑定的 scroll 目标（documentElement、body、visualViewport 等） */
  var extraScrollBindings = [];
  var feedback = root.querySelector('[data-scroll-popup-feedback]');
  var successPanel = root.querySelector('[data-scroll-popup-success]');
  var strings =
    window.theme &&
    window.theme.scrollNewsletterPopup &&
    window.theme.scrollNewsletterPopup.strings
      ? window.theme.scrollNewsletterPopup.strings
      : {};

  function detachTriggers() {
    window.removeEventListener('scroll', onScrollRaf, { capture: true });
    document.removeEventListener('scroll', onAnyScroll, { capture: true });
    window.removeEventListener('resize', onScrollRaf);
    window.removeEventListener('load', onLoadCheck);
    window.removeEventListener('pageshow', onPageShowRecheck);
    for (var ei = 0; ei < extraScrollBindings.length; ei++) {
      var b = extraScrollBindings[ei];
      if (!b || !b.node) continue;
      b.node.removeEventListener('scroll', onScrollRaf, { passive: true, capture: b.capture });
    }
    extraScrollBindings.length = 0;
    if (pollId !== null) {
      window.clearInterval(pollId);
      pollId = null;
    }
    if (delayTimerId !== null) {
      window.clearTimeout(delayTimerId);
      delayTimerId = null;
    }
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  }

  function bindExtraScroll(node, capture) {
    if (!node || typeof node.addEventListener !== 'function') return;
    node.addEventListener('scroll', onScrollRaf, { passive: true, capture: !!capture });
    extraScrollBindings.push({ node: node, capture: !!capture });
  }

  function onLoadCheck() {
    requestAnimationFrame(checkScroll);
  }

  function onPageShowRecheck() {
    requestAnimationFrame(checkScroll);
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) {
      closePopup();
    }
  }

  function teardownAll() {
    detachTriggers();
    document.removeEventListener('keydown', onKeydown);
    root.querySelectorAll('[data-scroll-popup-close]').forEach(function(el) {
      el.removeEventListener('click', onCloseClick);
    });
    if (form) {
      form.removeEventListener('submit', onFormSubmit);
    }
    var addCartBtnDetach = root.querySelector('[data-scroll-popup-add-cart]');
    if (addCartBtnDetach) {
      addCartBtnDetach.removeEventListener('click', onScrollPopupAddCart);
    }
    window.__wcSnlTeardown = null;
  }

  function onCloseClick() {
    closePopup();
  }

  function onScrollPopupAddCart(ev) {
    ev.preventDefault();
    var btn = ev.currentTarget;
    var pf = document.querySelector('[data-product-form]');
    var idInput = pf ? pf.querySelector('[name="id"]') : null;
    var qtyInput = pf ? pf.querySelector('[name="quantity"]') : null;
    var fallback = root.getAttribute('data-scroll-popup-variant-fallback');
    var variantId = idInput && idInput.value ? String(idInput.value) : fallback || '';
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    if (!variantId) {
      showNotification('This product is unavailable', 'error');
      return;
    }
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: quantity
      })
    })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(err) {
            throw err;
          });
        }
        return response.json();
      })
      .then(function(data) {
        if (data.items || data.id) {
          closePopup();
          return fetch('/cart.js').then(function(res) {
            return res.json();
          });
        }
        throw data;
      })
      .then(function(cart) {
        if (cart && cart.item_count != null) {
          updateCartCount(cart.item_count);
          renderCartDrawer(cart);
          openCartDrawer();
          var atcMsg =
            window.theme &&
            window.theme.scrollNewsletterPopup &&
            window.theme.scrollNewsletterPopup.addedToCart
              ? window.theme.scrollNewsletterPopup.addedToCart
              : 'Added to cart';
          showNotification(atcMsg, 'success');
        }
      })
      .catch(function(error) {
        var msg = (error && (error.description || error.message)) || 'Error adding to cart';
        showNotification(msg, 'error');
      })
      .then(function() {
        if (btn) btn.disabled = false;
      });
  }

  function openPopup() {
    if (opened) return;
    opened = true;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('scroll-newsletter-popup--open');
    var email = form ? form.querySelector('input[type="email"]') : null;
    if (email) {
      setTimeout(function() {
        try {
          email.focus();
        } catch (err) {}
      }, 200);
    }
  }

  function closePopup() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('scroll-newsletter-popup--open');
    opened = false;
    var dm = docScrollMetrics();
    var maxScroll = Math.max(0, dm.docH - dm.winH);
    if (maxScroll <= 0) {
      shortPageLocked = true;
    }
    armed = false;
  }

  function docScrollMetrics() {
    var se = document.scrollingElement || document.documentElement;
    var body = document.body;
    var de = document.documentElement;
    var stWin = window.scrollY != null ? window.scrollY : window.pageYOffset;
    var scrollTop = Math.max(
      stWin != null && !isNaN(stWin) ? stWin : 0,
      se.scrollTop || 0,
      de && de.scrollTop ? de.scrollTop : 0,
      body && body.scrollTop ? body.scrollTop : 0
    );
    var winH = window.innerHeight || (se && se.clientHeight) || (de && de.clientHeight) || (body && body.clientHeight) || 0;
    var docH = Math.max(
      se.scrollHeight || 0,
      body ? body.scrollHeight : 0,
      de ? de.scrollHeight : 0,
      se.offsetHeight || 0,
      body ? body.offsetHeight : 0
    );
    return { scrollTop: scrollTop, winH: winH, docH: docH };
  }

  function parseMidRatio() {
    var ratio = parseFloat(root.getAttribute('data-trigger-mid-ratio') || '0.5');
    if (isNaN(ratio)) ratio = 0.5;
    if (ratio < 0.05) ratio = 0.05;
    if (ratio > 0.95) ratio = 0.95;
    return ratio;
  }

  function parseDelayMs() {
    var ms = parseInt(root.getAttribute('data-trigger-delay-ms') || '30000', 10);
    if (isNaN(ms)) ms = 30000;
    if (ms < 0) ms = 0;
    return ms;
  }

  function checkScroll() {
    if (opened) return;
    var m = docScrollMetrics();
    var maxScroll = Math.max(0, m.docH - m.winH);
    var ratio = parseMidRatio();

    if (maxScroll <= 0) {
      if (m.docH <= 0 || shortPageLocked) return;
      if (!armed) return;
      openPopup();
      return;
    }

    var line = maxScroll * ratio;
    var releasePx = Math.max(100, m.winH * 0.12);

    if (!armed) {
      if (m.scrollTop < line - releasePx) {
        armed = true;
      }
      return;
    }

    if (m.scrollTop >= line) {
      openPopup();
    }
  }

  var ticking = false;
  function onScrollRaf() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function() {
      ticking = false;
      checkScroll();
    });
  }

  function onAnyScroll() {
    onScrollRaf();
  }

  window.addEventListener('scroll', onScrollRaf, { passive: true, capture: true });
  document.addEventListener('scroll', onAnyScroll, { passive: true, capture: true });
  bindExtraScroll(document.documentElement, true);
  if (document.body) bindExtraScroll(document.body, true);
  var scEl = document.scrollingElement;
  if (scEl && scEl !== document.documentElement) bindExtraScroll(scEl, true);
  if (window.visualViewport) bindExtraScroll(window.visualViewport, false);
  window.addEventListener('resize', onScrollRaf, { passive: true });
  window.addEventListener('load', onLoadCheck);
  window.addEventListener('pageshow', onPageShowRecheck);

  delayTimerId = window.setTimeout(function() {
    delayTimerId = null;
    if (!opened && armed && !shortPageLocked) {
      openPopup();
    }
  }, parseDelayMs());

  /* 首屏短时轮询：避免图片/fonts 拉高页面高度后错过检测 */
  var pollLeft = 25;
  pollId = window.setInterval(function() {
    if (--pollLeft < 0) {
      window.clearInterval(pollId);
      pollId = null;
      return;
    }
    if (!opened) {
      checkScroll();
    }
  }, 400);

  if (typeof ResizeObserver !== 'undefined') {
    resizeObserver = new ResizeObserver(function() {
      if (opened) return;
      requestAnimationFrame(checkScroll);
    });
    try {
      resizeObserver.observe(document.documentElement);
      if (document.body) resizeObserver.observe(document.body);
    } catch (e) {}
  }

  root.querySelectorAll('[data-scroll-popup-close]').forEach(function(el) {
    el.addEventListener('click', onCloseClick);
  });

  document.addEventListener('keydown', onKeydown);

  var scrollPopupAddCartBtn = root.querySelector('[data-scroll-popup-add-cart]');
  if (scrollPopupAddCartBtn) {
    scrollPopupAddCartBtn.addEventListener('click', onScrollPopupAddCart);
  }

  function onFormSubmit(e) {
    e.preventDefault();
    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    if (feedback) {
      feedback.hidden = true;
      feedback.textContent = '';
    }

    var action = form.getAttribute('action') || '/contact';
    var fd = new FormData(form);

    fetch(action, {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function(res) {
        if (submitBtn) submitBtn.disabled = false;
        if (res.ok) {
          form.setAttribute('hidden', '');
          if (successPanel) successPanel.removeAttribute('hidden');
        } else {
          if (feedback) {
            feedback.textContent = strings.error || 'Error';
            feedback.removeAttribute('hidden');
          }
        }
      })
      .catch(function() {
        if (submitBtn) submitBtn.disabled = false;
        if (feedback) {
          feedback.textContent = strings.error || 'Error';
          feedback.removeAttribute('hidden');
        }
      });
  }

  if (form) {
    form.addEventListener('submit', onFormSubmit);
  }

  try {
    checkScroll();
  } catch (e4) {}

  window.__wcSnlTeardown = teardownAll;
  window.__wcSnlInitialized = true;
}

/**
 * 世界杯倒计时（首页 worldcup-countdown 区块）
 */
function initWorldCupCountdown() {
  relocateWorldCupCountdownForMobile();

  var roots = document.querySelectorAll('[data-worldcup-countdown-root]');
  for (var ri = 0; ri < roots.length; ri++) {
    setupWorldCupCountdownRoot(roots[ri]);
  }

  if (!window.__wcCountdownShopifyListen) {
    window.__wcCountdownShopifyListen = true;
    document.addEventListener('shopify:section:load', function(ev) {
      relocateWorldCupCountdownForMobile();
      var t = ev.target;
      if (!t || !t.querySelector) return;
      var inner = t.querySelector('[data-worldcup-countdown-root]');
      if (inner) setupWorldCupCountdownRoot(inner);
    });
  }

  if (!window.__wcCountdownResizeListen) {
    window.__wcCountdownResizeListen = true;
    window.addEventListener('resize', relocateWorldCupCountdownForMobile);
  }
}

function relocateWorldCupCountdownForMobile() {
  var root = document.querySelector('[data-worldcup-countdown-root]');
  if (!root) return;

  var sectionEl = root.closest('.shopify-section');
  if (!sectionEl) return;

  var heroSection = document.querySelector('.shopify-section:has(> .hero--has-banner)');
  var heroComposer = document.querySelector('.hero--has-banner .hero__composer-bottom');
  var isMobile = window.matchMedia('(max-width: 768px)').matches;

  if (!heroSection || !heroComposer) return;

  if (!sectionEl.__wcCountdownHomeParent) {
    sectionEl.__wcCountdownHomeParent = sectionEl.parentNode;
    sectionEl.__wcCountdownHomeNext = sectionEl.nextSibling;
  }

  if (isMobile) {
    if (sectionEl.parentNode !== heroComposer.parentNode || sectionEl.nextElementSibling !== heroComposer) {
      heroComposer.insertAdjacentElement('beforebegin', sectionEl);
    }
    return;
  }

  if (sectionEl.parentNode !== sectionEl.__wcCountdownHomeParent) {
    if (sectionEl.__wcCountdownHomeNext) {
      sectionEl.__wcCountdownHomeParent.insertBefore(sectionEl, sectionEl.__wcCountdownHomeNext);
    } else {
      sectionEl.__wcCountdownHomeParent.appendChild(sectionEl);
    }
  }

  if (heroSection.nextElementSibling !== sectionEl) {
    heroSection.insertAdjacentElement('afterend', sectionEl);
  }
}

function setupWorldCupCountdownRoot(root) {
  if (!root) return;

  if (root.__wcCountdownTick) {
    window.clearInterval(root.__wcCountdownTick);
    root.__wcCountdownTick = null;
  }

  var cfgEl = root.querySelector('script.wc-countdown-config');
  if (!cfgEl) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }

  var labelEl = root.querySelector('[data-wc-countdown-label]');
  var timeEl = root.querySelector('[data-wc-countdown-time]');
  var statusEl = root.querySelector('[data-wc-countdown-status]');
  var isInline = root.classList.contains('worldcup-countdown--inline');

  var str = (cfg.strings && typeof cfg.strings === 'object') ? cfg.strings : {};
  var tStart = Date.parse(cfg.tournamentStart || '');
  var tEnd = Date.parse(cfg.tournamentEnd || '');

  var matchesRaw = Array.isArray(cfg.matches) ? cfg.matches : [];

  function partsFromMs(ms) {
    if (ms <= 0) return { d: 0, h: 0, m: 0, s: 0, done: true };
    var sec = Math.floor(ms / 1000);
    return {
      d: Math.floor(sec / 86400),
      h: Math.floor(sec / 3600) % 24,
      m: Math.floor(sec / 60) % 60,
      s: sec % 60,
      done: false
    };
  }

  function formatCountdownYmdHms(parts, targetMs) {
    var open = new Date(targetMs);
    var y = open.getFullYear();
    var mo = String(open.getMonth() + 1).padStart(2, '0');
    var dd = String(parts.d).padStart(2, '0');
    var h = String(parts.h).padStart(2, '0');
    var mi = String(parts.m).padStart(2, '0');
    var s = String(parts.s).padStart(2, '0');
    return y + '/' + mo + '/' + dd + ' ' + h + ':' + mi + ':' + s;
  }

  function formatCountdownMobileDaysHms(parts) {
    var d = String(parts.d).padStart(2, '0');
    var h = String(parts.h).padStart(2, '0');
    var mi = String(parts.m).padStart(2, '0');
    var s = String(parts.s).padStart(2, '0');
    return d + ' days ' + h + ':' + mi + ':' + s;
  }

  function isCountdownMobileViewport() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function inlineTimeText(parts, targetMs) {
    if (!isFinite(targetMs)) return '';
    if (isCountdownMobileViewport()) return formatCountdownMobileDaysHms(parts);
    return formatCountdownYmdHms(parts, targetMs);
  }

  function inlineOpeningLabel() {
    if (isCountdownMobileViewport()) return '2026 NA World Cup in';
    return str.openingLabel || '2026 North America World Cup Opening Countdown:';
  }

  function setInlineDisplay(labelText, timeText, statusText) {
    if (labelEl) labelEl.textContent = labelText || '';
    if (timeEl) timeEl.textContent = timeText ? ' ' + timeText : '';
    if (statusEl) statusEl.textContent = statusText || '';
  }

  /** @type {{ kick: number, title: string, meta: string }[]} */
  var matches = [];
  for (var mi = 0; mi < matchesRaw.length; mi++) {
    var row = matchesRaw[mi];
    if (!row) continue;
    var k = Date.parse(row.kickoffISO || '');
    if (!isFinite(k)) continue;
    matches.push({
      kick: k,
      title: row.title != null ? String(row.title) : '',
      meta: row.meta != null ? String(row.meta) : ''
    });
  }
  matches.sort(function(a, b) {
    return a.kick - b.kick;
  });

  function upcomingMatches(now) {
    var out = [];
    for (var i = 0; i < matches.length; i++) {
      if (matches[i].kick > now) out.push(matches[i]);
    }
    return out;
  }

  function tick() {
    var now = Date.now();
    var openingLabel = inlineOpeningLabel();

    if (!isInline) return;

    if (isFinite(tEnd) && now >= tEnd) {
      setInlineDisplay(str.postLede || '', '', str.postLede || '');
      if (root.__wcCountdownTick) {
        window.clearInterval(root.__wcCountdownTick);
        root.__wcCountdownTick = null;
      }
      return;
    }

    if (isFinite(tStart) && now < tStart) {
      var leftPre = tStart - now;
      setInlineDisplay(openingLabel, inlineTimeText(partsFromMs(leftPre), tStart), '');
      if (!isFinite(leftPre) || leftPre <= 0) tick();
      return;
    }

    var up = upcomingMatches(now);
    if (up.length > 0) {
      var leftRow = up[0].kick - now;
      if (leftRow <= 120000 && leftRow > 0 && str.liveSoon) {
        setInlineDisplay(openingLabel, str.liveSoon, up[0].title || '');
      } else if (leftRow <= 0) {
        setInlineDisplay(openingLabel, str.started || '', up[0].title || '');
      } else {
        setInlineDisplay(openingLabel, inlineTimeText(partsFromMs(leftRow), up[0].kick), up[0].title || '');
      }
      return;
    }

    setInlineDisplay(openingLabel, str.duringLede || '', '');
  }

  tick();
  root.__wcCountdownTick = window.setInterval(tick, 1000);
}

/**
 * Cart Functionality
 */
function initCart() {
  // Update cart count
  updateCartCount();
  
  // Listen for cart updates
  if (window.theme.PubSub) {
    window.theme.PubSub.subscribe(window.theme.CartEvents.UPDATED, function(cart) {
      updateCartCount(cart.item_count);
      showNotification('Cart updated', 'success');
    });
  }
}

function updateCartCount(count) {
  if (count === undefined) return;
  
  const cartCountElements = document.querySelectorAll('[data-cart-count]');
  cartCountElements.forEach(function(el) {
    el.textContent = count;
    el.classList.toggle('cart-count--visible', count > 0);
    el.classList.add('cart-count--updated');
    setTimeout(function() {
      el.classList.remove('cart-count--updated');
    }, 300);
  });
}

function escapeHtml(text) {
  if (text == null) return '';
  var d = document.createElement('div');
  d.textContent = String(text);
  return d.innerHTML;
}

function escapeAttr(text) {
  return String(text == null ? '' : text)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;');
}

function getCartDrawerStrings() {
  return window.theme && window.theme.cartDrawerStrings ? window.theme.cartDrawerStrings : {};
}

function buildCartDrawerBodyHTML(cart) {
  var s = getCartDrawerStrings();
  if (!cart.items || cart.items.length === 0) {
    return (
      '<div class="cart-drawer__empty">' +
      escapeHtml(s.empty || 'Your cart is empty') +
      '<br><a href="/collections/all">' +
      escapeHtml(s.continue_shopping || 'Continue shopping') +
      '</a></div>'
    );
  }
  var html = '';
  cart.items.forEach(function(item, index) {
    var line = index + 1;
    var imgSrc = item.image ? escapeHtml(item.image) : '';
    var productUrl = item.url ? String(item.url).trim() : '';
    var productHref = productUrl ? escapeAttr(productUrl) : '';
    var titleEscaped = escapeHtml(item.product_title || item.title);
    var imgAlt = escapeAttr(item.product_title || item.title || '');
    var imgInner =
      '<img class="cart-drawer__item-img" src="' +
      imgSrc +
      '" alt="' +
      imgAlt +
      '" width="72" height="72">';
    var imgTag = imgSrc
      ? productHref
        ? '<a href="' + productHref + '" class="cart-drawer__item-img-link">' + imgInner + '</a>'
        : imgInner
      : '<div class="cart-drawer__item-img"></div>';
    var vendor = item.vendor
      ? '<div class="cart-drawer__item-vendor">' + escapeHtml(item.vendor) + '</div>'
      : '';
    var titleHtml = productHref
      ? '<a href="' + productHref + '" class="cart-drawer__item-title-link">' + titleEscaped + '</a>'
      : titleEscaped;
    var variant =
      item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';
    var unit = '<p class="cart-drawer__item-unit">' + formatMoney(item.final_price) + '</p>';
    var lineTotal =
      '<span class="cart-drawer__item-line-total">' + formatMoney(item.final_line_price) + '</span>';
    var qtyControls =
      '<div class="cart-drawer__item-actions">' +
      '<div class="cart-drawer__qty" data-cart-drawer-line-wrap data-line="' +
      line +
      '" data-quantity="' +
      item.quantity +
      '">' +
      '<button type="button" data-drawer-qty-delta="-1" aria-label="Decrease">−</button>' +
      '<span>' +
      item.quantity +
      '</span>' +
      '<button type="button" data-drawer-qty-delta="1" aria-label="Increase">+</button>' +
      '</div>' +
      '<button type="button" class="cart-drawer__remove" data-cart-drawer-remove data-line="' +
      line +
      '" aria-label="Remove">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
      '</button>' +
      '</div>';
    html +=
      '<div class="cart-drawer__item" data-cart-drawer-item>' +
      imgTag +
      '<div class="cart-drawer__item-main">' +
      '<div class="cart-drawer__item-top">' +
      '<div>' +
      vendor +
      '<h3 class="cart-drawer__item-title">' +
      titleHtml +
      '</h3>' +
      variant +
      unit +
      '</div>' +
      lineTotal +
      '</div>' +
      qtyControls +
      '</div></div>';
  });
  return html;
}

function buildCartDrawerFooterHTML(cart) {
  var s = getCartDrawerStrings();
  var html = '';
  html +=
    '<details class="cart-drawer__note"><summary>' +
    escapeHtml(s.order_note || '') +
    '</summary><textarea data-cart-drawer-note placeholder="' +
    escapeAttr(s.order_note_placeholder || '') +
    '">' +
    escapeHtml(cart.note || '') +
    '</textarea></details>';

  var discountApps = cart.cart_level_discount_applications || [];
  var cartLevelAllocatedSum = 0;
  discountApps.forEach(function(app) {
    var raw = app.total_allocated_amount != null ? Number(app.total_allocated_amount) : 0;
    cartLevelAllocatedSum += raw;
  });

  if (discountApps.length > 0) {
    if (cartLevelAllocatedSum > 0) {
      discountApps.forEach(function(app) {
        var title = app.title || (app.discount_application && app.discount_application.title) || '';
        var amount = app.total_allocated_amount != null ? app.total_allocated_amount : 0;
        html +=
          '<div class="cart-drawer__discount-row">' +
          '<span>' +
          escapeHtml(title) +
          '</span> <span>(-' +
          formatMoney(amount) +
          ')</span></div>';
      });
    } else if (cart.total_discount > 0) {
      // change.js 等 AJAX 返回里偶现 cart_level 的 total_allocated_amount 全为 0，但 total_discount / total_price 仍正确
      if (discountApps.length === 1) {
        var single = discountApps[0];
        var singleTitle =
          single.title || (single.discount_application && single.discount_application.title) || 'Discount';
        html +=
          '<div class="cart-drawer__discount-row">' +
          '<span>' +
          escapeHtml(singleTitle) +
          '</span> <span>(-' +
          formatMoney(cart.total_discount) +
          ')</span></div>';
      } else {
        html +=
          '<div class="cart-drawer__discount-row"><span>Discount</span> <span>(-' +
          formatMoney(cart.total_discount) +
          ')</span></div>';
      }
    }
  } else if (cart.total_discount > 0) {
    html +=
      '<div class="cart-drawer__discount-row"><span>Discount</span> <span>(-' +
      formatMoney(cart.total_discount) +
      ')</span></div>';
  }

  html += '<div class="cart-drawer__total-row">';
  html +=
    '<span class="cart-drawer__total-label">' +
    escapeHtml(s.estimated_total || 'Estimated total') +
    '</span>';
  html +=
    '<span class="cart-drawer__total-amount">' +
    formatMoney(cart.total_price) +
    ' ' +
    escapeHtml(cart.currency || '') +
    '</span>';
  html += '</div>';
  html +=
    '<p class="cart-drawer__tax-note">' +
    escapeHtml(s.tax_note || '') +
    '</p>';
  html +=
    '<button type="button" class="cart-drawer__checkout" data-cart-drawer-checkout>' +
    escapeHtml(s.checkout || 'Check out') +
    '</button>';
  return html;
}

function renderCartDrawer(cart) {
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;
  var body = root.querySelector('[data-cart-drawer-body]');
  var footer = root.querySelector('[data-cart-drawer-footer]');
  if (!body || !footer) return;
  body.innerHTML = buildCartDrawerBodyHTML(cart);
  if (!cart.items || cart.item_count === 0) {
    footer.hidden = true;
    footer.innerHTML = '';
  } else {
    footer.hidden = false;
    footer.innerHTML = buildCartDrawerFooterHTML(cart);
  }
}

function openCartDrawer() {
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;
  root.classList.add('is-open');
  root.setAttribute('aria-hidden', 'false');
  document.body.classList.add('cart-drawer-open');
}

function closeCartDrawer() {
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;
  root.classList.remove('is-open');
  root.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('cart-drawer-open');
}

function refreshCartDrawerFromServer() {
  return fetch('/cart.js')
    .then(function(res) {
      return res.json();
    })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      return cart;
    });
}

function cartDrawerChangeLine(line, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ line: line, quantity: quantity })
  })
    .then(function(res) {
      if (!res.ok) {
        return res.json().then(function(err) {
          throw err;
        });
      }
      return res.json();
    })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      var root = document.querySelector('[data-cart-drawer]');
      if (root && root.classList.contains('is-open') && cart.item_count === 0) {
        /* 保留抽屉打开以展示空状态 */
      }
      return cart;
    });
}

var cartDrawerNoteTimer;
function initCartDrawer() {
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;

  root.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeCartDrawer();
      return;
    }
    var checkoutBtn = e.target.closest('[data-cart-drawer-checkout]');
    if (checkoutBtn) {
      e.preventDefault();
      var url = window.theme && window.theme.routes && window.theme.routes.checkout;
      window.location.href = url || '/checkout';
      return;
    }
    var deltaBtn = e.target.closest('[data-drawer-qty-delta]');
    if (deltaBtn) {
      e.preventDefault();
      var wrap = deltaBtn.closest('[data-cart-drawer-line-wrap]');
      if (!wrap) return;
      var line = parseInt(wrap.getAttribute('data-line'), 10);
      var qty = parseInt(wrap.getAttribute('data-quantity'), 10);
      var delta = parseInt(deltaBtn.getAttribute('data-drawer-qty-delta'), 10);
      var newQty = qty + delta;
      if (newQty < 0) newQty = 0;
      cartDrawerChangeLine(line, newQty).catch(function(err) {
        console.error(err);
        showNotification(
          (err.description || err.message || window.cartStrings.error) || 'Cart error',
          'error'
        );
      });
      return;
    }
    var removeBtn = e.target.closest('[data-cart-drawer-remove]');
    if (removeBtn) {
      e.preventDefault();
      var lineR = parseInt(removeBtn.getAttribute('data-line'), 10);
      cartDrawerChangeLine(lineR, 0).catch(function(err) {
        console.error(err);
        showNotification(
          (err.description || err.message || window.cartStrings.error) || 'Cart error',
          'error'
        );
      });
    }
  });

  root.addEventListener(
    'input',
    function(e) {
      if (!e.target.matches('[data-cart-drawer-note]')) return;
      clearTimeout(cartDrawerNoteTimer);
      var val = e.target.value;
      cartDrawerNoteTimer = setTimeout(function() {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: val })
        }).catch(function() {
          showNotification('Could not save note', 'error');
        });
      }, 500);
    },
    true
  );

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    if (root.classList.contains('is-open')) {
      closeCartDrawer();
    }
  });

  var triggers = document.querySelectorAll('[data-cart-drawer-trigger]');
  triggers.forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      refreshCartDrawerFromServer().then(function() {
        openCartDrawer();
      });
    });
  });
}

/**
 * Product Forms
 */
function initProductForms() {
  const productForms = document.querySelectorAll('[data-product-form]');
  
  productForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const submitButton = e.submitter || form.querySelector('[type="submit"]');
      const originalText = submitButton ? submitButton.innerHTML : '';
      
      // 获取 variant ID
      const idInput = form.querySelector('[name="id"]');
      const variantId = idInput ? idInput.value : '';
      const quantity = form.querySelector('[name="quantity"]')?.value || 1;
      
      // 如果 ID 为空，直接报错（Demo 产品保护）
      if (!variantId) {
        showNotification('This product is unavailable', 'error');
        return;
      }
      
      // Loading 状态
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.innerHTML = '<span class="loading-spinner"></span> Adding...';
      }
      
      // 用 JSON 格式提交（Shopify AJAX API 要求）
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: parseInt(quantity, 10)
        })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(err) { throw err; });
        }
        return response.json();
      })
      .then(function(data) {
        if (data.items || data.id) {
          if (submitButton) {
            submitButton.innerHTML = '✓ Added!';
          }
          fetch('/cart.js')
            .then(function(res) { return res.json(); })
            .then(function(cart) {
              updateCartCount(cart.item_count);
              renderCartDrawer(cart);
              openCartDrawer();
            });
          
          setTimeout(function() {
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.innerHTML = originalText;
            }
          }, 2000);
        } else {
          throw data;
        }
      })
      .catch(function(error) {
        console.error('Cart error:', error);
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.innerHTML = originalText;
        }
        var msg = (error.description || error.message || 'Error adding to cart');
        showNotification(msg, 'error');
      });
    });
  });
}

/**
 * Quantity Selectors
 */
/**
 * Quantity Selectors & Cart AJAX Updates
 */
function initQuantitySelectors() {
  document.addEventListener('click', function(e) {
    var btn = e.target;
    
    // 加号
    if (btn.matches('[data-quantity-plus]')) {
      e.preventDefault();
      var input = btn.parentElement.querySelector('[data-quantity-input]');
      if (!input) return;
      var value = parseInt(input.value, 10) || 0;
      input.value = value + 1;
      if (input.dataset.itemKey) updateCartItem(input);
    }
    
    // 减号
    if (btn.matches('[data-quantity-minus]')) {
      e.preventDefault();
      var input = btn.parentElement.querySelector('[data-quantity-input]');
      if (!input) return;
      var value = parseInt(input.value, 10) || 1;
      var min = parseInt(input.getAttribute('min'), 10);
      var floor = isNaN(min) ? 0 : min;
      if (value > floor) {
        input.value = value - 1;
        if (input.dataset.itemKey) updateCartItem(input);
      }
    }
    
    // Remove 删除按钮
    if (btn.matches('[data-remove-item]') || btn.closest('[data-remove-item]')) {
      e.preventDefault();
      var removeBtn = btn.matches('[data-remove-item]') ? btn : btn.closest('[data-remove-item]');
      var itemKey = removeBtn.dataset.itemKey;
      var input = document.querySelector('[data-quantity-input][data-item-key="' + itemKey + '"]');
      if (input) {
        input.value = 0;
        updateCartItem(input, true);
      }
    }
  });
}

/**
 * AJAX 更新购物车数量并刷新页面数字
 */
function updateCartItem(input, isRemove) {
  var form = input.closest('form');
  if (!form) return;
  
  var itemRow = input.closest('[data-cart-item]');
  if (itemRow) itemRow.style.opacity = '0.6';
  
  // 收集所有商品数量
  var allInputs = form.querySelectorAll('[data-quantity-input]');
  var updates = {};
  allInputs.forEach(function(inp) {
    updates[inp.dataset.itemKey] = parseInt(inp.value) || 0;
  });
  
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ updates: updates })
  })
  .then(function(res) { return res.json(); })
  .then(function(cart) {
    // 如果数量为0，移除该行
    if (isRemove || input.value == 0) {
      if (itemRow) itemRow.remove();
      if (cart.item_count === 0) {
        window.location.reload();
        return;
      }
    } else {
      // 更新当前行的 Total 价格
      var updatedItem = cart.items.find(function(item) { return item.key === input.dataset.itemKey; });
      if (updatedItem && itemRow) {
        var totalEl = itemRow.querySelector('.cart-item__total-price');
        if (totalEl) totalEl.textContent = formatMoney(updatedItem.final_line_price);
        
        var originalEl = itemRow.querySelector('.cart-item__original-price');
        if (originalEl) {
          if (updatedItem.original_line_price > updatedItem.final_line_price) {
            originalEl.textContent = formatMoney(updatedItem.original_line_price);
            originalEl.style.display = '';
          } else {
            originalEl.style.display = 'none';
          }
        }
      }
    }
    
    // 更新右侧 Order Summary
    updateCartSummary(cart);
    
    // 更新顶部购物车角标
    updateCartCount(cart.item_count);
    
    if (itemRow) itemRow.style.opacity = '1';
  })
  .catch(function(err) {
    console.error('Cart update error:', err);
    showNotification('Failed to update cart', 'error');
    if (itemRow) itemRow.style.opacity = '1';
  });
}

/**
 * 刷新右侧价格汇总
 */
function updateCartSummary(cart) {
  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.original_total_price);
  
  var totalEl = document.querySelector('[data-cart-total]');
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  
  // 折扣行
  var discountRow = document.querySelector('.cart-summary__row--discount');
  if (discountRow) {
    if (cart.total_discount > 0) {
      discountRow.style.display = 'flex';
      discountRow.querySelector('span:last-child').textContent = '-' + formatMoney(cart.total_discount);
    } else {
      discountRow.style.display = 'none';
    }
  }
}

/**
 * 金额格式化（分转元）
 */
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/**
 * Scroll Animations
 */
function initScrollAnimations() {
  const animatedElements = document.querySelectorAll('[data-animate]');
  
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });
    
    animatedElements.forEach(function(el) {
      observer.observe(el);
    });
  }
}

/**
 * Mobile Menu
 */
function initMobileMenu() {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('is-open');
      menuToggle.classList.toggle('is-active');
      document.body.classList.toggle('menu-open');
    });
  }
}

/**
 * Notification System
 */
function showNotification(message, type) {
  // Remove existing notifications
  const existingNotifications = document.querySelectorAll('.notification');
  existingNotifications.forEach(function(n) { n.remove(); });
  
  // Create notification
  const notification = document.createElement('div');
  notification.className = 'notification notification--' + type;
  notification.innerHTML = `
    <span class="notification__message">${message}</span>
    <button class="notification__close" onclick="this.parentElement.remove()">×</button>
  `;
  
  document.body.appendChild(notification);
  
  // Animate in
  setTimeout(function() {
    notification.classList.add('is-visible');
  }, 10);
  
  // Auto remove
  setTimeout(function() {
    notification.classList.remove('is-visible');
    setTimeout(function() {
      notification.remove();
    }, 300);
  }, 3000);
}

/**
 * Age Verification (if needed)
 */
function verifyAge() {
  const ageVerified = sessionStorage.getItem('ageVerified');
  
  if (!ageVerified && window.theme.settings.showAgeWarning) {
    showAgePopup();
  }
}

function showAgePopup() {
  const popup = document.createElement('div');
  popup.className = 'age-popup';
  popup.innerHTML = `
    <div class="age-popup__content">
      <div class="age-popup__badge">${window.theme.settings.ageRestriction}</div>
      <h2>Age Verification</h2>
      <p>This website contains collectible items recommended for ages ${window.theme.settings.ageRestriction} and up.</p>
      <p>By continuing, you confirm that you are ${window.theme.settings.ageRestriction} years of age or older.</p>
      <button class="button button--primary" onclick="confirmAge()">I Confirm</button>
    </div>
  `;
  
  document.body.appendChild(popup);
}

function confirmAge() {
  sessionStorage.setItem('ageVerified', 'true');
  const popup = document.querySelector('.age-popup');
  if (popup) {
    popup.remove();
  }
}

// Add notification styles
const notificationStyles = document.createElement('style');
notificationStyles.textContent = `
  .notification {
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 1.5rem 2rem;
    border-radius: 12px;
    display: flex;
    align-items: center;
    gap: 1rem;
    z-index: 10000;
    transform: translateX(120%);
    transition: transform 0.3s ease;
    box-shadow: 0 4px 20px rgba(0,0,0,0.2);
  }
  
  .notification.is-visible {
    transform: translateX(0);
  }
  
  .notification--success {
    background: #00A651;
    color: white;
  }
  
  .notification--error {
    background: #E31837;
    color: white;
  }
  
  .notification__message {
    font-size: 1.5rem;
    font-weight: 600;
  }
  
  .notification__close {
    background: none;
    border: none;
    color: inherit;
    font-size: 2rem;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.3s;
  }
  
  .notification__close:hover {
    opacity: 1;
  }
  
  .loading-spinner {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255,255,255,0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
document.head.appendChild(notificationStyles);
